import { authHeaders, getAuthBaseUrl } from './authApi';

// ─── Explorer reward store admin REST client ─────────────────────────────────
// Mirrors reportsAdminApi.js. All calls hit /api/admin/explorer-rewards* and
// require an admin JWT (Authorization: Bearer <token>).

export async function fetchRewardItems() {
  const base = getAuthBaseUrl();
  if (!base) return [];
  const res = await fetch(`${base}/api/admin/explorer-rewards/items`, { headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !Array.isArray(data.items)) {
    throw new Error(data.error || 'Failed to load reward items');
  }
  return data.items;
}

export async function saveRewardItem(item) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/explorer-rewards/items`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(item),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    return { success: false, error: data.error || 'Save failed' };
  }
  return { success: true, item: data.item };
}

export async function setRewardItemActive(itemId, active) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/explorer-rewards/items/${encodeURIComponent(itemId)}/active`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ active }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    return { success: false, error: data.error || 'Update failed' };
  }
  return { success: true };
}

export async function fetchRedemptions({ status = null } = {}) {
  const base = getAuthBaseUrl();
  if (!base) return [];
  const qs = status && status !== 'all' ? `?status=${encodeURIComponent(status)}` : '';
  const res = await fetch(`${base}/api/admin/explorer-rewards/redemptions${qs}`, { headers: authHeaders() });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !Array.isArray(data.redemptions)) {
    throw new Error(data.error || 'Failed to load redemptions');
  }
  return data.redemptions;
}

export async function resolveRedemption(redemptionId, { action, note = null }) {
  const base = getAuthBaseUrl();
  if (!base) return { success: false, error: 'API unavailable' };
  const res = await fetch(`${base}/api/admin/explorer-rewards/redemptions/${encodeURIComponent(redemptionId)}/resolve`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ action, note }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    return { success: false, error: data.error || 'Resolve failed' };
  }
  return { success: true };
}

// ─── Display helpers ─────────────────────────────────────────────────────────

export function redemptionStatusLabel(status) {
  switch (status) {
    case 'pending': return '待发放';
    case 'fulfilled': return '已发放';
    case 'cancelled': return '已取消（积分已退回）';
    default: return status || '—';
  }
}

export function formatIsoDate(iso, lang = 'zh') {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(lang === 'en' ? 'en-AU' : 'zh-CN', {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}
